const passportModel = {
  /**
   * 日付表記を取得
   * @param {*} date
   * @returns
   */
  getDateLabelOrPlaceholder(date) {
    if (!date) {
      return 'カレンダーを選択';
    }
    return window.$vm.$moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日');
  },
  /**
   * 日付表記を取得
   * @param {*} date
   * @returns
   */
  getDateLabel(date) {
    if (!date) {
      return '';
    }
    return window.$vm.$moment(date).format('YYYY年MM月DD日');
  },
  /**
   * 日付表記を取得
   * @param {*} date
   * @returns
   */
  getDateLabelYYYYMMDD(date) {
    if (!date) {
      return '';
    }
    return window.$vm.$moment(date).format('YYYYMMDD');
  },
  /**
   * 証明書種類の名称を取得
   * @param {*} type
   * @returns
   */
  getTypeLabel(type) {
    if (!type) {
      return '';
    }
    return Number(type) === 1 ? '戸籍附票' : '海外在留証明';
  },
};

export default passportModel;
